import { inject, Injectable } from '@angular/core';
import { Functions } from '@angular/fire/functions';
import { httpsCallable } from 'firebase/functions';
import { WINDOW } from 'moddy/common';

interface StripePortalLinkResponse {
    url?: string;
}

@Injectable({
    providedIn: 'root'
})
export class PlanSubscriptionService {
    private readonly functions = inject(Functions);
    private readonly getStripePortalLink = httpsCallable(this.functions, 'getStripePortalLink');
    private readonly window = inject(WINDOW);

    public async manage(): Promise<void> {
        const response = await this.getStripePortalLink();
        const data = response.data as StripePortalLinkResponse;

        if (data?.url) {
            this.window.location.href = data.url;
        }
    }
}
